module.exports = __webpack_public_path__ + "media/typy/motocykle@3x-0e6c7e7c.svg";